import { httpRequest } from "../../http";
import { ApprovedUrl } from "@models/approvedUrl.model";

/** Which rows the server returns. `inherited` is what the Page URL picker wants:
 *  the org plus its ancestors, never the platform-wide (PSA) list. */
export type ApprovedUrlScope = "own" | "inherited" | "platform";

export class CommandGetApprovedUrls {
    async run(organizationId: number, scope: ApprovedUrlScope = "own",
              activeOnly = false, signal?: AbortSignal): Promise<ApprovedUrl[]> {

        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/approved-urls/`;

        const params = new URLSearchParams({
            scope: scope,
            active_only: String(activeOnly),
        });

        const url = `${base}?${params.toString()}`;

        try {
            const response = await httpRequest<any>(url, { method: "GET", signal });
            return ApprovedUrl.fromJsonList(response);
        } catch (error) {
            if (signal?.aborted) throw error;
            console.error("Error fetching approved urls:", error);
            throw error;
        }
    }
}
